import { isCssVarColor } from './isCssColor.ts';
import { toComponentArray } from './toComponentArray.ts';
import type { Color } from '../../types/Color.d.ts';

/**
 * Normalizes to the RGBA string (with #) supported by CSS and similar. (E.g., #FF0000FF)
 * Supports anything that toComponentArray can handle for input.
 *
 * @param {Color} color
 * @return {string}
 */
export function normalizeToRGBAString(color?: Color): string {
  if (!color || isCssVarColor(color)) return '';

  const hexColor = toComponentArray(color)
    ?.map(v => `00${v.toString(16)}`.slice(-2)).join('')
    .toUpperCase();

  return `#${hexColor}`;
}